import React, { useState, useEffect } from "react";
import { Table, Alert, Spinner } from "react-bootstrap";

const CommissionView = ({ employeeId }) => {
  const [commission, setCommission] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCommission = async () => {
      try {
        const res = await fetch(`/api/employees/${employeeId}/commission`);
        const data = await res.json();
        if (data.error) throw new Error(data.error);
        setCommission(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCommission();
  }, [employeeId]);

  if (loading) return <Spinner animation="border" size="sm" />;
  if (error) return <Alert variant="danger">{error}</Alert>;
  if (!commission) return <p>No commission data.</p>;

  return (
    <div>
      <h4 className="mb-3">
        Commission Earnings - {commission.period}
      </h4>

      <div className="alert alert-info">
        <strong>Total Earned:</strong> ${commission.total_earned} 
        <span className="ms-3">
          <strong>Rate:</strong> {commission.rate}%
        </span>
      </div>

      {commission.items.length > 0 ? (
        <Table striped bordered hover responsive size="sm">
          <thead className="table-light">
            <tr>
              <th>Date</th>
              <th>Item</th>
              <th>Amount</th>
              <th>Commission</th>
            </tr>
          </thead>
          <tbody>
            {commission.items.map((item, i) => (
              <tr key={i}>
                <td>{new Date(item.date).toLocaleDateString()}</td>
                <td>{item.description}</td>
                <td>${parseFloat(item.item_amount).toFixed(2)}</td>
                <td>${parseFloat(item.commission).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Alert variant="secondary">No commissions earned in this period.</Alert>
      )}
    </div>
  );
};

export default CommissionView;